import { FacilitiesFragment } from 'pages/main/api/fragments/generated/Facilities.fragment';

export const getFacilityGroupId = (facilities?: FacilitiesFragment[], facilityId?: string | null) => {
  const facility = facilities?.find(facility => facility.id === facilityId);
  if (facility && facilityId) return facility.facilityGroupId ? facility.facilityGroupId : '';
  return '';
};
